export const openWindow = (url: string) => {
	window?.open(url, '_blank', 'noopener,noreferrer');
};
